
export const SET_PLAYBACK_INDEX = "SET_PLAYBACK_INDEX";

export const SET_PLAYBACK_BOOL_TO_TRUE = "SET_PLAYBACK_BOOL_TO_TRUE";
export const SET_PLAYBACK_BOOL_TO_FALSE = "SET_PLAYBACK_BOOL_TO_FALSE";

export const RESET_PLAYBACK = "RESET_PLAYBACK";